import { Component } from '@angular/core';
import { SanitizeHtmlPipe } from '../../pipes/sanitize.pipe';
@Component({
  selector: 'live-view',
  styleUrls: ['./live-view.component.scss'],
  templateUrl: "./live-view.component.html"
})
export class LiveViewComponent {
  public data: string;
  public teste = 123;
}
